export const capitalizeText = text => {
  // Check if the input is a valid string
  if (typeof text !== 'string' || text.length === 0) {
    return '';
  }

  // Capitalize the first letter and return the modified string
  return text.charAt(0).toUpperCase() + text.slice(1);
}